import * as React from 'react';
import { useReporting } from '../../hooks/useReporting';
import { DatasetTotalResultEnum } from '../../@shared/Models/Reporting/ReportingResult';
import moment from 'moment';
import { Palette } from '../../@shared/palette';
import "react-datepicker/dist/react-datepicker.css";
import { ChartItem } from '../../hooks/useCharts';
import LineChartComponent from '../../components/LineChart';
import { ReportingProviderInstance } from '../../@shared/services/ReportingProvider';
import { ReportingWithIdModel } from '../../@shared/Models/Reporting/ReportingWithIdModel';


export type TabsContentMonitoringModelUsageProps = {
  schemaId: string;
}

const TabsContentMonitoringDataSize = (props: TabsContentMonitoringModelUsageProps) => {
  const [prefix, setPrefix] = React.useState<string>("Byte");

  const items = React.useMemo((): ChartItem[] => {
    return [
      { label: "Dataset size", color: Palette.btnPrimary, key: "dataset", postfix: prefix },
      { label: "Test Dataset size", color: Palette.textColorWarning, key: "test", postfix: prefix }
    ];
  }, [prefix]);

  const _reportingProviderInstance = React.useMemo(() => ReportingProviderInstance, []);

  const reportingHook = useReporting({
    onLoadData: async (input) => {
      return await _reportingProviderInstance.dataset(input as ReportingWithIdModel);
    }
  });

  React.useEffect(() => {
    reportingHook.onLoadDataset(props.schemaId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.schemaId, reportingHook.baseRequest]);


  const data = React.useMemo(() => {
    if (!reportingHook.dataResults?.data || reportingHook.isLoadingDataset) {
      return [];
    }

    let divider = 1;
    const maxValue = Math.max(...reportingHook.dataResults.data[DatasetTotalResultEnum.DataSize].map(item => item.value));
    if (maxValue > 1024 * 1024 * 1024) {
      divider = 1024 * 1024 * 1024;
      setPrefix("GB");
    }
    else if (maxValue > 1024 * 1024) {
      divider = 1024 * 1024;
      setPrefix("MB");
    }
    else if (maxValue > 1024) {
      divider = 1024;
      setPrefix("KB");
    }
    else {
      setPrefix("Byte");
    }

    return reportingHook.dataResults.data[DatasetTotalResultEnum.DataSize].map((item, index) => {
      return {
        name: reportingHook.baseRequest.granularityInMinutes >= 1440 ? moment(item.date).format("MMM DD") : moment(item.date).format("MMM DD H:mm"),
        dataset: +(item.value / divider).toFixed(2),
        test: +(reportingHook.dataResults!.data![DatasetTotalResultEnum.DataSizeTest][index].value / divider).toFixed(2),
      };
    });
  }, [reportingHook.baseRequest.granularityInMinutes, reportingHook.dataResults, reportingHook.isLoadingDataset]);

  return <LineChartComponent {...reportingHook} items={items} data={data} title='Dataset size' />
}

export default TabsContentMonitoringDataSize;
